<template>
  <section>
    <ViewLoader v-if="loading"/>
    <div class="container intro-section center-page-content" v-else>
      <div class="row">
        <div class="col text-center">

          <div v-if="orderIdValid">
            <Icon name="grCheckCircleBroken" width="36" class="mb-3"/>
            <h2 class="title">
              {{ $t('pages.checkout_success.title') }}
            </h2>
          </div>
          <div v-else>
            <Icon name="grAlertTriangle" width="36" class="mb-3"/>
            <h2 class="title">
              {{ $t('pages.checkout_error.title') }}
            </h2>
          </div>

        </div>
      </div>
    </div>
  </section>
</template>


<script>
import CartService from "@/services/Cart.js"
import ViewLoader from "@/components/ViewLoader";

export default {
  data() {
    return {
      orderIdValid: false,
      loading: true
    }
  },
  components: {
    ViewLoader
  },

  beforeMount() {
    window.scrollTo(0, 0);
  },

  mounted() {
    if (this.$route.query.redirect_status === 'succeeded') {
      this.checkValidityOrder(this.$route.query.order)
    } else {
      this.loading = false
      this.orderIdValid = false
    }
  },
  methods: {
    async checkValidityOrder(orderId) {
      this.orderIdValid = false;
      if (!orderId) return;

      try {
        await CartService.getOrders({orderId: orderId});
        this.orderIdValid = true;
      } catch (error) {
        this.orderIdValid = false
      } finally {
        this.loading = false;
      }
    }
  },

  computed: {}
}
</script>
